import { render, staticRenderFns } from "./saleschannel-info.vue?vue&type=template&id=0f7b698f&scoped=true"
import script from "./saleschannel-info.vue?vue&type=script&lang=js"
export * from "./saleschannel-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7b698f",
  null
  
)

export default component.exports